import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import Alert from "../../components/Alert";
import MyPage from "../../../src/MyPage";
import SubTabsInputs from "../../../src/SubTabsInputs.js";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

  export default class InputsRetunrs extends Component{ 

    constructor(props){
      super(props);

      this.state={
          returns:[],
          modalTitle:"",
          returnid:0,
          countryid:0,
          warehouseid: 0,
          yearid: 0,
          productid:0,
          migration: false,
          july:"",
          august:"",
          september:"",
          october: "",
          november: "",
          december: "",
          january: "",
          february: "",
          march: "",
          april: "",
          may: "",
          june:"",
          countryRegion: {
			countryid:0,
			countryname:"",
			regionid:0,
			region: {
				regionname: "",
				regionid:0
			}
		},
        warehouse: {
			warehouseid:0,
			warehousename:""
		},
		year: {
			yearid:0,
			fyname:"",
			migration: true
		},
		product: {
			productid:0,
			sapcode: "",
			productdescription: ""
		},

          CountryNameFilter:"",
          RegionNameFilter:"",
          WarehouseNameFilter:"",
          FiscalYearFilter:"",
          ProductIdFilter:"",
          ProductDescriptionFilter:"",
          ReturnIdFilter:"",
          MigrationFilter:"",
          returnsWithoutFilter:[],
          regionNames: [],
          countryNames: [],
          fiscalYears: [], 
          productdescriptions: [],
          warehouseNames: [],
          loading: true, 
          isEditClicked: false,
          kits:[],
          products:[],
          productLabels:[],
          productlabelname:"",
          SapcodeDupNames:[],
          SapcodeDupDescriptionNames:[],
          SapcodeNames:[],
          SapcodeDescriptionNames:[],
      }
  }

  FilterFn(){
    var CountryNameFilter = this.state.CountryNameFilter;
    var RegionNameFilter = this.state.RegionNameFilter;
    var WarehouseNameFilter = this.state.WarehouseNameFilter;
    var FiscalYearFilter = this.state.FiscalYearFilter;
    var ProductIdFilter = this.state.ProductIdFilter;
    var ProductDescriptionFilter = this.state.ProductDescriptionFilter;
    var ReturnIdFilter = this.state.ReturnIdFilter;
    var MigrationFilter = this.state.MigrationFilter;


    var filteredData=this.state.returnsWithoutFilter.filter(
        function(el){
            return el.countryRegion.countryname.toString().toLowerCase().includes(
                CountryNameFilter.toString().trim().toLowerCase()
            )&&  
                el.countryRegion.region.regionname.toString().toLowerCase().includes(
                RegionNameFilter.toString().trim().toLowerCase()
            )&&  
                el.warehouse.warehousename.toString().toLowerCase().includes(
                WarehouseNameFilter.toString().trim().toLowerCase()
            )&&  
                el.year.fyname.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )&&  
                el.product.productdescription.toString().toLowerCase().includes(
                ProductDescriptionFilter.toString().trim().toLowerCase()
            )&&  
                el.returnid.toString().toLowerCase().includes(
                ReturnIdFilter.toString().trim().toLowerCase()
            )&&
            el.migration.toString().toLowerCase().includes(
                MigrationFilter.toString().trim().toLowerCase()
            )&&
            el.product?.sapcode.toString().toLowerCase().includes(
                ProductIdFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({returns:filteredData});

}

sortResult(prop,asc){
  var sortedData=this.state.returnsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({returns:sortedData});

}


changeCountryNameFilter = (e)=>{
  this.state.CountryNameFilter=e.target.value;
  this.FilterFn();
}

changeRegionNameFilter = (e)=>{
    this.state.RegionNameFilter=e.target.value;
    this.FilterFn();
  }

changeWarehouseNameFilter = (e)=>{
    this.state.WarehouseNameFilter=e.target.value;
    this.FilterFn();
  }

changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }


  changeProductIdFilter = (e)=>{
    this.state.ProductIdFilter=e.target.value;
    this.FilterFn();
  }

changeProductDescriptionFilter = (e)=>{
    this.state.ProductDescriptionFilter=e.target.value;
    this.FilterFn();
  }


changeReturnIdFilter = (e)=>{
    this.state.ReturnIdFilter=e.target.value;
    this.FilterFn();
  }

  changeMigrationFilter = (e)=>{
    this.state.MigrationFilter=e.target.value;
    this.FilterFn();
  }

refreshList = () => {
    axiosService.get('/returns/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ returns: data, returnsWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };



fetchRegionNames() {
  axiosService.get('/regionnames/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const regionNames = data.map(item => item.regionname);
      this.setState({ regionNames: regionNames });
    })
    .catch(error => {
      console.error("Error fetching region names:", error);
    });
}


fetchCountryNames() {
  axiosService.get('/countries/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const countryNames = filteredData.map(item => item.countryname);
      this.setState({ countryNames: countryNames });
    })
    .catch(error => {
      console.error("Error fetching country names:", error);
    });
}

fetchFiscalYears() {
    axiosService.get('/years/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const fiscalYears = filteredData.map(item => item.fyname);
        this.setState({ fiscalYears: fiscalYears });
      })
      .catch(error => {
        console.error("Error fetching fiscal years:", error);
      });
  }

  fetchProductDescriptions() {
    axiosService.get('/defaultproducts/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const productdescriptions = data.map(item => item.productdescription);
        this.setState({ productdescriptions: productdescriptions });
      })
      .catch(error => {
        console.error("Error fetching products :", error);
      });
  }

  fetchWarehouseNames() {
    axiosService.get('/warehouses/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const warehouseNames = filteredData.map(item => item.warehousename);
        this.setState({ warehouseNames: warehouseNames });
      })
      .catch(error => {
        console.error("Error fetching warehouse names:", error);
      });
  }

handleInput = (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/;
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/[^0-9]/g, '');
    }
  };

  fetchProducts() {
    axiosService.get('/defaultproductscreate/') // Replace with the appropriate API endpoint for products
      .then((response) => {
        const data = response.data?.results ?? response.data;
        // Filter the data where purchasetypeid is equal to 1
        const filteredData = data.filter((item) => item.productlabelid === 1 && item.isactive === true);
  
        // Extract unique warehouseid values from the filtered data
        const products = filteredData.map((item) => item.productdescription);
  
        this.setState({ products: products });
      })
      .catch((error) => {
        console.error('Error fetching Products data:', error);
      });
  }

  fetchKits() {
    axiosService.get('/defaultproductscreate/') // Replace with the appropriate API endpoint for products
      .then((response) => {
        const data = response.data?.results ?? response.data;
        // Filter the data where purchasetypeid is equal to 1
        const filteredData = data.filter((item) => item.productlabelid === 2 && item.isactive === true);
  
        // Extract unique warehouseid values from the filtered data
        const kits = filteredData.map((item) => item.productdescription);
  
        this.setState({ kits: kits });
      })
      .catch((error) => {
        console.error('Error fetching Products data:', error);
      });
  }

  fetchProductLables() {
    axiosService.get('/productlabels/') // Replace with the appropriate API endpoint for products
      .then((response) => {
        const data = response.data?.results ?? response.data;
       
        const productLabels = data.map((item) => item.productlabelname);
  
        this.setState({ productLabels: productLabels });
      })
      .catch((error) => {
        console.error('Error fetching ProductLabels data:', error);
      });
  }

  
  
fetchSapcodeDupNames() {
  axiosService.get('/defaultkits/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const SapcodeDupNames = filteredData.map(item => item.sapcodedup);

      const sapcodeToProductDescriptionMap = {};
      filteredData.forEach(item => {
        sapcodeToProductDescriptionMap[item.sapcodedup] = item.productdescription;
      });

      this.setState({ SapcodeDupNames: SapcodeDupNames,SapcodeDupDescriptionNames:sapcodeToProductDescriptionMap  });
    })
    .catch(error => {
      console.error("Error fetching product sapcode:", error);
    });
}

findProductDescriptionForSapcodeDup(sapcodedup) {
  const productDescriptionMap = this.state.SapcodeDupDescriptionNames;
  return productDescriptionMap[sapcodedup] || "Kit not found";
}


fetchProductNames() {
  axiosService.get('/defaultitems/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const productNames = filteredData.map(item => item.productdescription);
      this.setState({ productNames: productNames });
    })
    .catch(error => {
      console.error("Error fetching product names:", error);
    });
}

fetchSapcodeNames() {
  axiosService.get('/defaultitems/')
    .then(response => {
      const data = response.data?.results ?? response.data;
      const filteredData = data.filter(item => item.isactive === true);
      const SapcodeNames = filteredData.map(item => item.sapcode);

      const sapcodeToProductDescriptionMap = {};
      filteredData.forEach(item => {
        sapcodeToProductDescriptionMap[item.sapcode] = item.productdescription;
      });

      this.setState({ SapcodeNames: SapcodeNames,SapcodeDescriptionNames:sapcodeToProductDescriptionMap  });
    })
    .catch(error => {
      console.error("Error fetching product sapcode:", error);
    });
}

findProductDescriptionForSapcode(sapcode) {
  const productDescriptionMap = this.state.SapcodeDescriptionNames;
  return productDescriptionMap[sapcode] || "Product not found";
}

componentDidMount(){
  this.refreshList();
  this.fetchRegionNames();
  this.fetchCountryNames();
  this.fetchFiscalYears();
  this.fetchProductDescriptions();
  this.fetchWarehouseNames();
  this.fetchProducts();
  this.fetchKits();
  this.fetchProductLables();
  this.fetchSapcodeDupNames();
  this.fetchSapcodeNames();
}

changeCountryName =(e)=>{
  this.setState({countryname:e.target.value});
}


changeRegionName =(e)=>{
  this.setState({regionname:e.target.value});
}

changeFiscalYear =(e)=>{
    this.setState({fyname:e.target.value});
  }

changeProductDescription =(e)=>{
    this.setState({productdescription:e.target.value});
  }

  changeMigration = (event) => {
    const isChecked = event.target.checked;
    this.setState({ migration: isChecked });
  };

changeJuly =(e)=>{
    this.setState({july:e.target.value});
  }

changeAugust =(e)=>{
    this.setState({august:e.target.value});
  }

changeSeptember =(e)=>{
    this.setState({september:e.target.value});
  }

changeOctober =(e)=>{
    this.setState({october:e.target.value});
  }
changeNovember =(e)=>{
    this.setState({november:e.target.value});
  }

changeDecember =(e)=>{
    this.setState({december:e.target.value});
  }

changeJanuary=(e)=>{
    this.setState({january:e.target.value});
  }

changeFebruary =(e)=>{
    this.setState({february:e.target.value});
  }

changeMarch =(e)=>{
    this.setState({march:e.target.value});
  }

changeApril =(e)=>{
    this.setState({april:e.target.value});
  }

changeMay =(e)=>{
    this.setState({may:e.target.value});
  }

changeJune =(e)=>{
    this.setState({june:e.target.value});
  }

addClick(){
  this.setState({
      modalTitle:"Add Return",
      returnid:0,
      countryid:0,
      countryname:"",
      warehousename:"",
      fyname:"",
      productdescription:"",
      migration: true,
      july:"",
      august:"",
      september:"",
      october:"",
      november:"",
      december:"",
      january:"",
      february:"",
      march:"",
      april:"",
      may:"",
      june:"",
      isEditClicked: false,
  });
}


editClick(dep) {
  this.setState({
    modalTitle: "Edit Return",
    returnid: dep.returnid,
    countryid: dep.countryid,
    countryname: dep.countryRegion.countryname,
    warehousename:dep.warehouse.warehousename,
    fyname:dep.year.fyname,
    productdescription:dep.product.productdescription,
    migration:dep.migration,
    july:dep.july,
    august:dep.august,
    september:dep.september,
    october:dep.october,
    november:dep.november,
    december:dep.december,
    january:dep.january,
    february:dep.february,
    march:dep.march,
    april:dep.april,
    may:dep.may,
    june:dep.june,
    initialCountryname: dep.countryRegion.countryname,
    initialWarehousename:dep.warehouse.warehousename,
    initialFyname:dep.year.fyname,
    initialProductdescription:dep.product.productdescription,
    initialJuly:dep.july,
    initialAugust:dep.august,
    initialSeptember:dep.september,
    initialOctober:dep.october,
    initialNovember:dep.november,
    initialDecember:dep.december,
    initialJanuary:dep.january,
    initialFebruary:dep.february,
    initialMarch:dep.march,
    initialApril:dep.april,
    initialMay:dep.may,
    initialJune:dep.june,
    initialMigration:dep.migration,
    isEditClicked: true,
  });
}

createClick() {
  const { countryname, warehousename, fyname, productdescription,migration, july, august, september, october,
  november, december, january, february, march, april, may, june } = this.state;

  if (!countryname) {
    alert('Country is required');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  axiosService.post('/returnscreate/', {
    countryname: countryname,
    warehousename: warehousename,
    fyname: fyname,
    productdescription:productdescription,
    migration: migration,
    july:july,
    august:august,
    september:september,
    october:october,
    november:november,
    december:december,
    january:january,
    february:february,
    march:march,
    april:april,
    may:may,
    june:june
  })
    .then(result => {
      alert('Return created');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {
  const { countryname, warehousename, fyname, productdescription,migration, july, august, september, october,
    november, december, january, february, march, april, may, june, initialCountryname,
    initialWarehousename, initialFyname, initialProductdescription,initialMigration, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune  } = this.state;

  if (
    countryname === initialCountryname &&
    warehousename === initialWarehousename&&
    fyname === initialFyname &&
    productdescription === initialProductdescription &&
    migration === initialMigration &&
    july === initialJuly &&
    august === initialAugust &&
    september === initialSeptember &&
    october === initialOctober &&
    november === initialNovember &&
    december === initialDecember &&
    january === initialJanuary &&
    february === initialFebruary &&
    march === initialMarch &&
    april === initialApril &&
    may === initialMay &&
    june === initialJune
  ) {
    alert('No changes detected');
    return;
  }


  if (!countryname) {
    alert('Country is required');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  
  axiosService.patch('/returns/' + id + '/', {
    countryid: this.state.countryid,
    countryname: this.state.countryname,
    warehousename: this.state.warehousename,
    fyname: this.state.fyname,
    productdescription : this.state.productdescription,
    migration:this.state.migration,
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june
  })
    .then(result => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


copyClick() {
  const { countryname, warehousename, fyname, productdescription,migration, july, august, september, october,
    november, december, january, february, march, april, may, june, initialCountryname,
    initialWarehousename, initialFyname, initialProductdescription,initialIsactive, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune  } = this.state;


  if (!countryname) {
    alert('Country is required');
    return;
  }


  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (!productdescription) {
    alert('Product is required');
    return;
  }

  axiosService.post('/returnscreate/', {
    countryid: this.state.countryid,
    countryname: this.state.countryname,
    warehousename: this.state.warehousename,
    fyname: this.state.fyname,
    productdescription : this.state.productdescription,
    migration:this.state.migration,
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june
  })
    .then(result => {
      alert('Return created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/returns/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload();
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      returns,
      modalTitle,
      returnid,
      countryid,
      countryname,
      warehousename,
      regionname,
      fyname,
      productdescription,
      migration,
      july,
      august,
      september,
      october,
      november,
      december,
      january,
      february,
      march,
      april,
      may,
      june,
      loading,
      products,
      kits,
      productlabelname, 

  }=this.state;

  return(
    
<div className="scrollable-container">
<MyPage />
<SubTabsInputs />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Add Return
</button>
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
      style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeReturnIdFilter}
      placeholder="Filter"/>

      </div>
      ReturnId
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "150px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductIdFilter}
      placeholder="Filter"/>
      </div>
      Product SAP Code / SKU
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "100px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeProductDescriptionFilter}
      placeholder="Filter"/>
      </div>
      Product
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
  style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeMigrationFilter}
      placeholder="Filter"/>
      </div>
      Migration
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      placeholder="Filter"/>
      </div>
      Fiscal Year
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeRegionNameFilter}
      placeholder="Filter"/>
      </div>
      Region
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeCountryNameFilter}
      placeholder="Filter"/>
      </div>
      Country
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeWarehouseNameFilter}
      placeholder="Filter"/>
      </div>
      Warehouse
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {returns.map(dep=>
      <tr key={dep.returnid} className="row-hover">
          <td className="table-text">{dep.returnid}</td>
          <td className="table-text">{dep.product?.sapcode ?? 'N/A'}</td>
          <td className="table-text">{dep.product?.productdescription ?? 'N/A'}</td>
          <td className="table-text">{dep.migration.toString()}</td>
          <td className="table-text">{dep.year?.fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.countryRegion?.region?.regionname ?? 'N/A'}</td>
          <td className="table-text">{dep.countryRegion?.countryname ?? 'N/A'}</td>
          <td className="table-text">{dep.warehouse?.warehousename ?? 'N/A'}</td>
          <td className="table-text">{dep.july ?? 'N/A'}</td>
          <td className="table-text">{dep.august ?? 'N/A'}</td>
          <td className="table-text">{dep.september ?? 'N/A'}</td>
          <td className="table-text">{dep.october ?? 'N/A'}</td>
          <td className="table-text">{dep.november ?? 'N/A'}</td>
          <td className="table-text">{dep.december ?? 'N/A'}</td>
          <td className="table-text">{dep.january ?? 'N/A'}</td>
          <td className="table-text">{dep.february ?? 'N/A'}</td>
          <td className="table-text">{dep.march ?? 'N/A'}</td>
          <td className="table-text">{dep.april ?? 'N/A'}</td>
          <td className="table-text">{dep.may ?? 'N/A'}</td>
          <td className="table-text">{dep.june ?? 'N/A'}</td>
          <td className="table-text">

          <div style={{ display: "flex", justifyContent: "center" }}>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal2"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.returnid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-primary m-2"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal1"
          onClick={()=>this.editClick(dep)}
          style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
            >
             Copy
          </button>
          </div>
          

          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>
<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Country</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Warehouse</span>
          <select
            className="form-select"
            value={this.state.warehousename}
            onChange={(event) => this.setState({ warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a warehouse</option>
            {this.state.warehouseNames.map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >ProductType</span>
          <select
            className="form-select"
            value={this.state.productlabelname}
            onChange={(event) => this.setState({ productlabelname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select productType</option>
            {this.state.productLabels.map((productlabel) => (
              <option key={productlabel} value={productlabel}>
                {productlabel}
              </option>
            ))}
          </select>
        </div>


        {this.state.productlabelname === "FULL" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode= event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcodeDup(selectedSapcode);
      this.setState({ productdescription: productdescription });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select kit SAPCODE</option>
    {this.state.SapcodeDupNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>

)}

{this.state.productlabelname === "FULL" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}

{this.state.productlabelname === "UNIT" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      this.setState({ productdescription: productdescription });
    }}
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>
)}


{this.state.productlabelname === "UNIT" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Migration</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={migration}
            onChange={this.changeMigration}
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        {returnid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {returnid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(returnid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal1" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            
            style={{ fontSize: "12px" }}
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Country</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
            
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Warehouse</span>
          <select
            className="form-select"
            value={this.state.warehousename}
            onChange={(event) => this.setState({ warehousename: event.target.value })}
            
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a warehouse</option>
            {this.state.warehouseNames.map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >ProductType</span>
          <select
            className="form-select"
            value={this.state.productlabelname}
            onChange={(event) => this.setState({ productlabelname: event.target.value })}
            
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select productType</option>
            {this.state.productLabels.map((productlabel) => (
              <option key={productlabel} value={productlabel}>
                {productlabel}
              </option>
            ))}
          </select>
        </div>


        {this.state.productlabelname === "FULL" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode= event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcodeDup(selectedSapcode);
      this.setState({ productdescription: productdescription });
    }}
    
    style={{ fontSize: "12px" }}
  >
    <option value="">Select kit SAPCODE</option>
    {this.state.SapcodeDupNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>

)}

{this.state.productlabelname === "FULL" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Kit Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}

{this.state.productlabelname === "UNIT" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item SAP Code / SKU</span>
  <select
    className="form-select"
    value={this.state.sapcode}
    onChange={(event) => {
      const selectedSapcode = event.target.value;
      this.setState({ sapcode: selectedSapcode });
      // Automatically find and set the corresponding productdescription
      const productdescription = this.findProductDescriptionForSapcode(selectedSapcode);
      this.setState({ productdescription: productdescription });
    }}
    
    style={{ fontSize: "12px" }}
  >
    <option value="">Select item SAPCODE</option>
    {this.state.SapcodeNames.map((sapcode) => (
      <option key={sapcode} value={sapcode}>
        {sapcode}
      </option>
    ))}
  </select>
</div>
)}


{this.state.productlabelname === "UNIT" && (
<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>

)}


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Migration</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={migration}
            onChange={this.changeMigration}
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        {returnid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}

        {returnid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal2" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }}>{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Country</span>
          <select
            className="form-select"
            value={this.state.countryname}
            onChange={(event) => this.setState({ countryname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a country</option>
            {this.state.countryNames.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Warehouse</span>
          <select
            className="form-select"
            value={this.state.warehousename}
            onChange={(event) => this.setState({ warehousename: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }}
          >
            <option value="">Select a warehouse</option>
            {this.state.warehouseNames.map((warehouse) => (
              <option key={warehouse} value={warehouse}>
                {warehouse}
              </option>
            ))}
          </select>
        </div>


<div className="input-group mb-3">
  <span className="input-group-text" style={{ fontSize: "12px" }}>Item Name</span>
  <input
    type="text"
    className="form-control"
    value={this.state.productdescription} // Make sure you're using the component state for productdescription
    onChange={(event) => this.setState({ productdescription: event.target.value })} // Update productdescription state
    disabled={this.state.isEditClicked}
    style={{ fontSize: "12px" }}
    readOnly // Set the readOnly attribute
  />
</div>




        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Migration</span>
          <input
            type="checkbox"
            className="form-check-input"
            style={{width: "1.5rem", height: "1.5rem", marginLeft: "10px" }}
            checked={migration}
            onChange={this.changeMigration}
          />
        </div>


        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          onInput={this.handleInput}
          style={{ fontSize: "12px" }}
          />

        </div>

        {returnid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {returnid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(returnid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>
</div>
  )
}
  }




